import { supabase } from '../../../services/supabase';
import { GetTicketCheckInsResponse } from '../types/queryTypes';

export async function getTicketCheckIns(
  checkInId: string[],
): Promise<GetTicketCheckInsResponse[]> {
  const { data: ticketCheckIns } = (await supabase
    .from('ticket_check_ins')
    .select(
      `
        *,
        ticket:ticket_id (
          ticket_number,
          external_link
        )
      `,
    )
    .in('check_in_id', checkInId)) as {
    data: GetTicketCheckInsResponse[] | null;
  };

  return ticketCheckIns || [];
}
